"use strict";var e=require("./maybe.js"),r=e.maybe((function(){return globalThis}))||e.maybe((function(){return window}))||e.maybe((function(){return self}))||e.maybe((function(){return global}))||e.maybe((function(){return e.maybe.constructor("return this")()}));module.exports=r;
//# sourceMappingURL=global.js.map
